module.exports = __webpack_public_path__ + "img/empty_order.60a551de.png";